import React from "react";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { TEAM, TEL_HREF, MAILTO, whatsappHref } from "../mock";

const iconFor = (type) => {
  if (type === "phone") return Phone;
  if (type === "email") return Mail;
  return MessageCircle;
};

const hrefFor = (type, person) => {
  if (type === "phone") return TEL_HREF;
  if (type === "email") return MAILTO;
  return whatsappHref(`Ciao ${person.name}, vi scrivo dal sito Carmaps.`);
};

export default function Contact() {
  return (
    <section id="contatti" className="cm-reveal py-20 lg:py-28">
      <div className="mx-auto max-w-[1360px] px-6 lg:px-10">
        <div className="max-w-[560px]">
          <p className="label-mono mb-5">Persone reali</p>
          <h2 className="h-display text-[clamp(2rem,4.2vw,3.4rem)]">
            Preferisci parlare al telefono?
          </h2>
          <p className="mt-6 text-[1.02rem] leading-relaxed text-[#5b5b54]">
            Chiama per informazioni, organizzare un appuntamento o gestire
            direttamente l'acquisto, in modo efficace, senza brutte sorprese.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-10 border-t border-[var(--cm-line)] pt-12 md:grid-cols-2 md:gap-0">
          {TEAM.map((person, idx) => (
            <div
              key={person.name}
              className={idx === 1 ? "md:pl-14 md:border-l md:border-[var(--cm-line)]" : ""}
            >
              <div className="flex items-center gap-4">
                {person.photo && (
                  <div className="h-16 w-16 shrink-0 overflow-hidden rounded-full border border-[var(--cm-line)] ring-2 ring-white">
                    <img
                      src={person.photo}
                      alt={person.name}
                      className="h-full w-full scale-110 object-cover"
                    />
                  </div>
                )}
                <div>
                  <h3 className="text-[1.7rem] font-semibold leading-none">{person.name}</h3>
                  <p className="mt-2 font-mono-cm text-[0.68rem] uppercase tracking-[0.14em] text-[#8a8a82]">
                    {person.role}
                  </p>
                </div>
              </div>
              <div className="mt-6 flex flex-wrap gap-3">
                {person.actions.map((a) => {
                  const Icon = iconFor(a.type);
                  const isWa = a.type === "whatsapp";
                  return (
                    <a
                      key={a.label}
                      href={hrefFor(a.type, person)}
                      target={isWa ? "_blank" : undefined}
                      rel={isWa ? "noopener noreferrer" : undefined}
                      className="inline-flex items-center gap-2 rounded-lg border border-[var(--cm-line)] px-5 py-3 font-mono-cm text-[0.7rem] uppercase tracking-[0.14em] transition-all duration-200 hover:border-[var(--cm-ink)] hover:bg-[var(--cm-ink)] hover:text-white"
                    >
                      <Icon size={14} />
                      {a.label}
                    </a>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
